<template>
  <div class="">
    <top-header :type="6" :hasBorder="true" :placeholder="'房源'" :bgColor="'#fff'" fontSize="0.32rem"/>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="">
        </div>
        <div class="list_con old_list">
          <div class="inner m_flex_box flex_vc" v-for="(item, index) in list" :key="index" @click="toDetail('/houseDetail', {houseListedId: item.id,mainId:item.mainId,compType:compType})">
            <div class="inner_l">
              <img class="banner" v-lazy="imgPath + 'sClf/' + item.fileId + '.jpg'">
            </div>
            <div class="new_r">
              <div class="m_flex_box flex_vc flex_jz tit">
                <h4 class="line_comp1">{{item.tgmc ? item.tgmc : '-'}}</h4>
                <i>在售</i>
              </div>
              <p class="line_comp1 col_gray">
                {{item.xzqh | format()}} / {{item.zmjCount ? item.zmjCount+'m²' : '-'}} / {{item.room ? item.room : '-'}}室{{item.hall ? item.hall : '-'}}厅</p>
              <div class="m_flex_box flex_jz">
                <div class="price m_flex_box flex_vb">
                  <h4>{{item.listedPrice ? item.listedPrice / 10000+'万' : '暂无'}}</h4>
                  <p>{{item.unitPrice ? item.unitPrice+'元/平' : '-'}}</p>
                </div>
                <a @click.stop="callTo(item.phoneNum, item.listedType, item.listedUserId)" class="tel"><img
                  src="@/assets/img/tel.png" alt=""></a>
              </div>
              <div class="num m_flex_box flex_vc">
                <img src="@/assets/img/check.png" alt=""><span>核验编码</span>{{item.uniqueCode ? item.uniqueCode : '暂无'}}
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from '@/components/header'
export default {
  name: 'HouseOraList',
  data() {
    return {
      isLoading: false,
      listPage: 1,
      loading: false,
      finished: false,
      list: [],
      timer: null,
      area: this.$route.query.area,
      compId: this.$route.query.compId,
      compType: this.$route.query.compType,
      storeId: this.$route.query.storeId,
    };
  },
  components: {
    topHeader,
  },

  filters: {
    format(data) {
      if (data === "320302000000") {
        return "鼓楼区";
      } else if (data === "320311000000") {
        return "泉山区";
      } else if (data === "320303000000") {
        return "云龙区";
      } else if (data === "320398000000") {
        return "金山桥";
      } else if (data === "320312000000") {
        return "铜山区";
      } else if (data === "320305000000") {
        return "贾汪区";
      } else if (data === "320399000000") {
        return "高新区";
      } else if (data === "320397000000") {
        return "港务区";
      }else if (data === "320382000000") {
        return "邳州市";
      } else if (data === "320381000000") {
        return "新沂市";
      } else if (data === "320321000000") {
        return "丰县";
      } else if (data === "320324000000") {
        return "睢宁";
      } else if (data === "320322000000") {
        return "沛县";
      } else if (data === "320") {
        return "市区";
      }
    }
  },

  mounted() {
  },
  methods: {
    callTo(phone, lx, infoId) {
      if(!phone) {
        this.$dialog.alert({
          title: '提示',
          message: '暂无可拨打电话'
        });
        return;
      }
      this.$http.post('cms/onlineUser/reg/isLogin.do').then(res => {
        if (res.success) {
          this.$new.post('telTj/addTeltj.do', qs.stringify({
            phone,
            lx,
            infoId
          })).then(res => {
            window.location.href = `tel:${phone}`
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },

    onRefresh() {
      this.finished = false;
      this.$set(this, 'list', []);
      this.$set(this, 'listPage', 1);
      this.onLoad(1);
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$http({
          url: 'cms/houseListed/permit/getHouseByInfo.do',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            compType: this.compType,
            pageSize: 10,
            offset: (this.listPage - 1) * 10,
            area: this.area,
            compId: this.compId,
            storeId: this.storeId,
          }
        }).then(res => {
          if (type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj.rows)
            this.loading = false;
            this.listPage += 1;
          } else {
            this.finished = true;
          }
        })
      }
    },
    toDetail(path, json) {
      this.$router.push({
        path,
        query: json
      })
    },
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'HouseDetail'){
      this.$store.dispatch('saveView', ['HouseOraList']).then(() => {
        next()
      })
    } else {
      this.$store.dispatch('saveView', []).then(() => {
        next()
      })
    }
  },
};
</script>
<style lang="less" scoped>
  .list_con{
    margin: 0.05rem auto 0;
    width: 7.04rem;
    .inner{
      padding: 0.35rem 0;
      border-bottom: 1px solid #F4F4F4;
    }
    .banner{
      width: 2.44rem;
      height: 1.84rem;
    }
    .new_r{
      .tel{
        width: 0.36rem;
        height: 0.36rem;
        img{
          width: 100%;
        }
      }
      img{
        width: 100%;
      }
      width: 4.25rem;
      margin-left: 0.3rem;
      .col_gray{
        font-size: 0.24rem;
        color: #505050;
      }
      .tit{
        h4{
          font-size: 0.36rem;
          color: #101010;
          font-weight: 800;
          width: 3rem;
        }
        i{
         // width: 0.6rem;
          padding: 0 0.04rem;
          line-height: 0.34rem;
          color: #2F72F5;
          font-size: 0.24rem;
          text-align: center;
          border: 1px solid currentColor;
          box-sizing: border-box;
          border-radius: 0.02rem;
        }
        span{
          width: 0.6rem;
          height: 0.34rem;
          text-align: center;
          line-height: 0.34rem;
          color: #fff;
          background-color: #24D064;
          font-size: 0.24rem;
          border-radius: 0.02rem;
        }
      }
    }
  }
  .old_list{
    .inner{
      .inner_l{
        position: relative;
        i{
          width: 0.6rem;
          height: 0.34rem;
          text-align: center;
          line-height: 0.34rem;
          color: #fff;
          background-color: #24D064;
          font-size: 0.24rem;
          position: absolute;
          display: block;
          top: 0;
        }
      }
      .new_r{
        .tit{
          margin-bottom: 0.08rem;
        }
        .col_gray{
          margin: 0.04rem 0;
        }
        .price{
          h4{
            font-size: 0.34rem;
            color: #FF4532;
            margin-bottom: 0;
            font-weight: 800;
          }
          p{
            font-size: 0.24rem;
            color: #AAAAAA;
            margin-left: 0.12rem;
          }
        }
        .num{
          margin-top: 0.04rem;
          color: #3072F5;
          img{
            width: 0.3rem;
            height: 0.3rem;
          }
          span{
            margin: 0 0.1rem;
            color: #383333;
          }
        }
      }
    }
  }
</style>